import React, { Component, Fragment } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import RejectActionConfirmation from "./RejectActionConfirmation";
import Button from "../../../shared/button/Button";
import Sending from "../../../shared/loaders/Sending";
import ModalThankYou from "../../../shared/loaders/ModalThankYou";
import {
  Wrapper,
  Form,
  Label,
  Field,
  TextInput,
  ButtonsWrapper,
  Error,
  Note,
  PlaceholderBtn,
  Asterisk,
} from "./styles/reject-candidate-styles";

class RejectCandidate extends Component {
  constructor(props) {
    super(props);
    const { cardData } = this.props;
    const { status } = cardData;

    this.state = {
      formLoading: false,
      successMessageActive: false,
      rejectMessage: "",
      actionConfirmationActive: status === "offered",
      error: null,
    };
  }

  showSuccessMessage = () => {
    this.setState({ successMessageActive: true });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ formLoading: true });
    const { rejectMessage } = this.state;
    const { cardData, closeActionModalAfterSubmit, fetchKanbanData } =
      this.props;
    const { updateStatusLink } = cardData;
    const url = updateStatusLink;

    const formData = new FormData();

    formData.append("application_action[action]", "rejected_candidate");
    formData.append("application_action[message]", rejectMessage);
    formData.append("application_action[action_at]", Date.now());

    const payload = {
      url,
      method: "post",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    };

    axios(payload)
      .then(() => {
        this.setState({ formLoading: false, error: null });
        this.showSuccessMessage();
        setTimeout(() => {
          closeActionModalAfterSubmit();
          fetchKanbanData({ loading: false, updating: true });
        }, 2000);
      })
      .catch((error) => {
        this.setState({
          error: error.response.data.errors,
          formLoading: false,
        });
      });
  };

  handleRejectMessage = (e) => {
    this.setState({ rejectMessage: e.target.value });
  };

  handleCancel = (e) => {
    e.preventDefault();
    const { closeActionModalAfterReset } = this.props;
    this.setState({ rejectMessage: "", error: null });
    closeActionModalAfterReset();
  };

  handleActionConfirmation = (e) => {
    e.preventDefault();
    this.setState({
      actionConfirmationActive: false,
    });
  };

  render() {
    const {
      formLoading,
      successMessageActive,
      rejectMessage,
      error,
      actionConfirmationActive,
    } = this.state;
    const { cardData } = this.props;
    const { candidate, agent } = cardData;

    return (
      <Wrapper>
        {actionConfirmationActive ? (
          <RejectActionConfirmation
            handleCancel={this.handleCancel}
            handleActionConfirmation={this.handleActionConfirmation}
          />
        ) : (
          <Fragment>
            {formLoading && <Sending />}
            {successMessageActive && (
              <ModalThankYou text="Candidate successfully rejected" />
            )}
            <Form onSubmit={this.handleSubmit}>
              <Label>
                Please let <strong>{agent}</strong> know why you want to reject{" "}
                <strong>{candidate}</strong>
                {rejectMessage.length < 30 && "*"}.
                <br />
                <br />
                Before you reject, think of the human being who will receive
                this. <br /> If this were your application, what would you like
                as constructive feedback?
              </Label>
              <Field>
                <TextInput
                  error={error}
                  value={rejectMessage}
                  placeholder="Add your message here..."
                  onChange={this.handleRejectMessage}
                />
                {error && error.message && (
                  <Error className="animated bounceIn">
                    Message {error.message}.
                  </Error>
                )}
                {rejectMessage.length < 30 && (
                  <Note>
                    <Asterisk note>*</Asterisk>
                    minimum of 30 characters
                  </Note>
                )}
              </Field>
              <ButtonsWrapper>
                <Button
                  secondary
                  buttonName="Cancel"
                  onClickAction={this.handleCancel}
                />
                {rejectMessage.length < 30 ? (
                  <PlaceholderBtn>Reject Candidate</PlaceholderBtn>
                ) : (
                  <Button primary buttonName="Reject candidate" type="submit" />
                )}
              </ButtonsWrapper>
            </Form>
          </Fragment>
        )}
      </Wrapper>
    );
  }
}

RejectCandidate.propTypes = {
  closeActionModalAfterReset: PropTypes.func.isRequired,
  closeActionModalAfterSubmit: PropTypes.func.isRequired,
  cardData: PropTypes.shape({
    candidate: PropTypes.string,
    agent: PropTypes.string,
    status: PropTypes.string,
    updateStatusLink: PropTypes.string,
  }).isRequired,
  fetchKanbanData: PropTypes.func.isRequired,
};

export default RejectCandidate;
